var map = {
	"./A0001000.png": 1019,
	"./A0001000.svg": 9148,
	"./A0001001.png": 6194,
	"./A0001001.svg": 1341,
	"./A0001002.png": 7161,
	"./A0001002.svg": 9246,
	"./android-chrome-192x192.png": 1072,
	"./android-chrome-256x256.png": 688,
	"./apple-touch-icon.png": 4375,
	"./co2-neutral-inverse.svg": 1529,
	"./cookie.svg": 3062,
	"./favicon-16x16.png": 794,
	"./favicon-32x32.png": 6654,
	"./germany.svg": 2071,
	"./item_missing-alt2.png": 1835,
	"./item_missing-alt2.svg": 7436,
	"./logo.png": 3798,
	"./mastercard.svg": 4704,
	"./mstile-150x150.png": 8536,
	"./newsletter.svg": 9213,
	"./novomind.png": 7311,
	"./novomind_logo.png": 4489,
	"./novosales_logo.png": 5126,
	"./packs.png": 177,
	"./packster-der-verpackungsshop-big.png": 9531,
	"./packster-der-verpackungsshop.png": 1254,
	"./packster-logo-footer.svg": 1891,
	"./packster_logo-big.png": 4817,
	"./packster_logo.png": 2100,
	"./packster_logo.svg": 8051,
	"./packster_logo_eu_claim_neg_rgb-big.png": 7820,
	"./packster_logo_eu_claim_neg_rgb.png": 585,
	"./packster_logo_eu_claim_neg_rgb.svg": 6014,
	"./packster_logo_mobile.png": 9171,
	"./packster_logo_old.png": 7570,
	"./payment_logo_americanexpress.png": 7356,
	"./payment_logo_klarna.png": 8643,
	"./payment_logo_maestro.png": 5693,
	"./payment_logo_mastercard.png": 5456,
	"./payment_logo_mastercard_square.png": 8776,
	"./payment_logo_mastercard_white.png": 2350,
	"./payment_logo_paypal.png": 477,
	"./payment_logo_sofort.png": 7577,
	"./payment_logo_visa.png": 4471,
	"./paypal.svg": 7049,
	"./safari-pinned-tab.svg": 8005,
	"./site.webmanifest": 8706,
	"./united-kingdom.svg": 9177,
	"./visa.svg": 2435
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3317;